module.exports = __webpack_public_path__ + "img/dumpattenuator_parked.389726ea.svg";